const reportScores = [
  { label: "comply-1 transparency", score: "0.97", threshold: "≥ 0.90", warn: false },
  { label: "comply-7 C2PA marking", score: "0.92", threshold: "≥ 0.90", warn: false },
  { label: "robust-2 jailbreak", score: "0.88", threshold: "≥ 0.85", warn: false },
  { label: "fair-4 demographic parity", score: "0.81", threshold: "≥ 0.80", warn: true },
  { label: "human-3 over-refuse", score: "0.95", threshold: "≥ 0.90", warn: false },
];

export default function Report() {
  return (
    <section id="sample" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-file-text-line" />
            What you ship
          </p>
          <h2 className="section-title">
            One PDF an auditor can re-run
          </h2>
          <p className="section-lede">
            Every assessment produces a single document with raw evidence, scores, model version, and a checksum.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="card border-foreground-200/50 shadow-xl shadow-background-200/50 overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="flex-1 p-5 md:p-6 lg:p-8 border-b lg:border-b-0 lg:border-r border-background-200/70">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-2 h-2 rounded-full bg-primary-500" />
                  <span className="text-xs font-medium text-foreground-500">Report #AC-2026-08412</span>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4">
                  Voice Assistant v3.1 · Article 50 audit
                </h3>
                <ul className="space-y-2.5 text-sm text-foreground-700 mb-5">
                  <li>
                    <strong className="text-foreground-900">Model:</strong> gpt-eu-3.1 · commit a4f8e2
                  </li>
                  <li>
                    <strong className="text-foreground-900">Date:</strong> 2026-07-14 · 14:02 UTC
                  </li>
                  <li>
                    <strong className="text-foreground-900">Scope:</strong> EU production, 28 languages
                  </li>
                  <li>
                    <strong className="text-foreground-900">Checksum:</strong> sha256:7d3c…e1f0
                  </li>
                  <li className="flex items-center gap-2">
                    <strong className="text-foreground-900">Verdict:</strong>
                    <span className="inline-flex items-center gap-1 text-primary-700 font-medium">
                      <i className="ri-check-line" />
                      Compliant
                    </span>
                    <span className="text-foreground-500">with 1 minor observation</span>
                  </li>
                </ul>
                <a
                  href="/sample-report.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost text-sm inline-flex items-center gap-1"
                >
                  View full sample <i className="ri-arrow-right-line" />
                </a>
              </div>

              <div className="flex-1 p-5 md:p-6 lg:p-8 bg-background-50/50">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {reportScores.map((item) => (
                    <div
                      key={item.label}
                      className={`p-3 md:p-4 rounded-lg border ${
                        item.warn
                          ? "bg-accent-50 border-accent-200/60"
                          : "bg-primary-50 border-primary-200/60"
                      }`}
                    >
                      <div className="flex items-baseline gap-2 mb-1">
                        <strong className={`text-xl md:text-2xl font-bold ${
                          item.warn ? "text-accent-700" : "text-primary-700"
                        }`}>
                          {item.score}
                        </strong>
                        <em className="text-xs text-foreground-500">{item.threshold}</em>
                      </div>
                      <span className="text-xs text-foreground-600">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}